import React, { useEffect, useState } from 'react'

import {
  BarLoader,
  Button,
  BUTTON_COLOR,
  BUTTON_THEME,
  Icon,
  Modal,
} from '@st-operations/uikit/src/v2'

import Header from '_components/header'
import TabView from '../tab-view'
import ProcessTab from './ProcessTab'
import LogsTab from './LogsTab'

import { useModal } from '_hooks'

import {
  approveAllByBatchId,
  getBatchProcess,
  stopBatchProcess,
  deleteBatchProcess,
} from '_services/batch-prebuillt-attributes'

import './styles.scss'

const TABS = ['Process', 'Approval Logs']

const BatchPrebuiltAttributeProcess = (props) => {
  const {
    match: {
      params: { id },
    },
  } = props
  const [process, setProcess] = useState(null)
  const [refreshProcess, setRefreshProcess] = useState(0)
  const [activeTab, setActiveTab] = useState(TABS[0])

  const {
    isOpen: isOpenApprove,
    handleOpenModal: handleOpenModalApprove,
    handleCloseModal: handleCloseModalApprove,
  } = useModal(false)
  const {
    isOpen: isOpenDelete,
    handleOpenModal: handleOpenModalDelete,
    handleCloseModal: handleCloseModalDelete,
  } = useModal(false)

  useEffect(() => {
    setProcess(null)
    getBatchProcess(id)
      .then(setProcess)
      .catch((error) => toast.error(error?.message))
  }, [id, refreshProcess])

  const handleExit = () => window._history.push(`/batch-prebuilt-attributes`)

  const handleRefresh = () => setRefreshProcess(Math.random())

  const handleApproveAll = () =>
    approveAllByBatchId(id)
      .then(() => {
        toast.success('Initiating approval workflow')
        handleExit()
      })
      .catch((error) => toast.error(error?.message))

  const handleStopBatch = () => {
    stopBatchProcess(id)
      .then(() => {
        toast.success('Batch Stopped')
        handleRefresh()
      })
      .catch((error) => toast.error(error?.message))
  }

  const handleDelete = () => {
    deleteBatchProcess(id)
      .then(() => {
        toast.success('Process Deleted')
        handleExit()
      })
      .catch((error) => toast.error(error?.message))
  }

  const getMainAction = () => {
    if (process.approvalProcess === 'running') {
      return {
        children: (
          <span className="bpa-process__approve-button">
            Stop Approval Process
            <Icon type="outline" icon="info" />
          </span>
        ),
        onClick: handleStopBatch,
        color: BUTTON_COLOR.RED,
        title: 'Process is currently running',
      }
    } else if (process.approvalProcess === 'stopped') {
      return {
        children: (
          <span className="bpa-process__approve-button">
            Restart Approval Process
            <Icon type="outline" icon="info" />
          </span>
        ),
        onClick: handleOpenModalApprove,
        title: 'Only approve un-approved audiences',
      }
    } else {
      return {
        children: (
          <span className="bpa-process__approve-button">
            Approve All
            <Icon type="outline" icon="info" />
          </span>
        ),
        onClick: handleOpenModalApprove,
        title: 'Only approve un-approved audiences',
      }
    }
  }

  if (!process) return <BarLoader />

  return (
    <div className="bpa-process">
      <Header
        title={`Process: ${process.name}`}
        actions={[
          {
            children: 'Exit',
            onClick: handleExit,
            theme: BUTTON_THEME.GHOST,
          },
          {
            children: 'Refresh',
            onClick: handleRefresh,
            theme: BUTTON_THEME.GHOST,
          },
          getMainAction(),
          {
            children: 'Delete',
            theme: BUTTON_THEME.GHOST,
            color: BUTTON_COLOR.RED,
            onClick: handleOpenModalDelete,
          },
        ]}
      />
      <TabView options={TABS} active={activeTab} onSelect={setActiveTab} />
      <Choose>
        <When condition={TABS[0] === activeTab}>
          <ProcessTab audiences={process.audiences} />
        </When>
        <When condition={TABS[1] === activeTab}>
          <LogsTab logs={process.approvalLogs} />
        </When>
      </Choose>
      <Modal isOpen={isOpenApprove} onClose={handleCloseModalApprove}>
        <div>
          <h2>Batch Approve Notice</h2>
          <p>
            You're about to approve {process?.audiences?.length} audience
            {process?.audiences?.length > 1 ? 's' : ''}. This process will run in the background and
            may take some time. Refresh this page to check the status for each one.
          </p>
          <Button onClick={handleCloseModalApprove} theme={BUTTON_THEME.SECONDARY}>
            Cancel
          </Button>
          <Button onClick={handleApproveAll}>Confirm</Button>
        </div>
      </Modal>
      <Modal isOpen={isOpenDelete} onClose={handleCloseModalDelete}>
        <div>
          <h2>Deleting Process</h2>
          <p>This will not affect the audiences.</p>
          <Button onClick={handleCloseModalDelete} theme={BUTTON_THEME.SECONDARY}>
            Cancel
          </Button>
          <Button onClick={handleDelete} color={BUTTON_COLOR.RED}>
            Confirm
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default BatchPrebuiltAttributeProcess
